import queryString from 'query-string';

import request from 'utils/request';
import { getUserCurrentStore } from 'utils/auth';

export const API_BASE_URL = `${process.env.REACT_APP_BASE_URL_API}/api`;

export function getReportsFiltersRequest({ includeUsers }, options = {}) {
  const storeUuid = getUserCurrentStore()?.uuid;

  const query = queryString.stringify({
    store_uuid: storeUuid,
    include_users: includeUsers,
    group_pay_types: true,
  });

  return request(`${API_BASE_URL}/v1/reports/sales-config/?${query}`, {
    method: 'GET',
    ...options,
  });
}
